module.exports = __webpack_public_path__ + "img/icon_tickcircle.a4ff9702.svg";